var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28659 10.6668H3.71309C1.42634 10.6668 0.666504 9.50293 0.666504 8.3335V3.66683C0.666504 1.91544 1.42634 1.3335 3.71309 1.3335H8.28659C10.5733 1.3335 11.3332 1.91544 11.3332 3.66683V8.3335C11.3332 10.0849 10.5661 10.6668 8.28659 10.6668Z",
    stroke: "#0D1116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2617 9.0558L11.5 7.88778V4.10822L13.2617 2.94021C14.1236 2.37117 14.8333 2.71858 14.8333 3.71888V8.28311C14.8333 9.28341 14.1236 9.63082 13.2617 9.0558Z",
    stroke: "#0D1116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 5.3335C8.88578 5.3335 9.3335 4.88578 9.3335 4.3335C9.3335 3.78121 8.88578 3.3335 8.3335 3.3335C7.78121 3.3335 7.3335 3.78121 7.3335 4.3335C7.3335 4.88578 7.78121 5.3335 8.3335 5.3335Z",
    stroke: "#0D1116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.76fbfcf792ca2aba032e68147a51f889.svg";
export { ForwardRef as ReactComponent };